import CommentType from "./comment-type";


const NotificationTypes = [
    {
        'name': 'All',
        'value': 'all',
        'color': '#000000',
        'message': 'have commented.'
    }, {
        "name": "community comment",
        "value": "community-comment",
        "color": "#5e5e5e",
        "message": "have commented on community forum"
    },
    ...CommentType,{
        "name": "reply",
        "value": "reply",
        "color": "#b42424",
        "message": "replied to your comment"

    },
    {
        'name': 'Like',
        'value': 'like',
        "color": "#b42424",
        "message": "liked your comment"
    }
]

export default NotificationTypes